import request from '@/src/utils/request'

/**
 * 取得加購標籤列表（不含已軟刪）
 * @returns {Promise}
 */
export const getHotelGoodsTags = async () => {
  return await request.get('/admin/hotel/goods-tags')
}

/**
 * 取得單筆加購標籤
 * @param {string} tagId
 * @returns {Promise}
 */
export const getHotelGoodsTag = async (tagId) => {
  return await request.get(`/admin/hotel/goods-tag/${tagId}`)
}

/**
 * 建立加購標籤（主鍵 UUID 由前端產生，放入 path）
 * @param {string} tagId - 前端產生的 UUID
 * @param {object} data
 * @param {string} data.name
 * @param {string} [data.color] - Element UI tag type: 'default' | 'success' | 'info' | 'warning' | 'danger'
 * @returns {Promise}
 */
export const createHotelGoodsTag = async (tagId, data) => {
  return await request.post(`/admin/hotel/goods-tag/${tagId}`, data)
}

/**
 * 部分更新加購標籤（至少 name 或 color 擇一）
 * @param {string} tagId
 * @param {object} data
 * @param {string} [data.name]
 * @param {string} [data.color]
 * @returns {Promise}
 */
export const updateHotelGoodsTag = async (tagId, data) => {
  return await request.patch(`/admin/hotel/goods-tag/${tagId}`, data)
}

/**
 * 軟刪除加購標籤
 * @param {string} tagId
 * @returns {Promise}
 */
export const deleteHotelGoodsTag = async (tagId) => {
  return await request.delete(`/admin/hotel/goods-tag/${tagId}`)
}
